module.exports = __webpack_public_path__ + "static/media/iphone_apple_card_dark.a800afb0.svg";